import { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { selectConfig } from 'Redux/auth/utils'

const TABS = {
  requestsToBeApproved: 1,
  approvedRequests: 2,
  rejectedRequests: 3,
  weekSummary: 4,
}

const useApproverCartsTabs = () => {
  const closeToAutoApproved = useSelector(state => state.approver.closeToAutoApproved)
  const requestOrder = useSelector(state => state.approver.requestOrder)
  const isFetchingCart = useSelector(state => state.approver.isFetchingCart)
  const features = useSelector(selectConfig)

  const [activeTab, setActiveTab] = useState(TABS.requestsToBeApproved)
  const [showPendingModal, setShowPendingModal] = useState(false)
  const [isFirstRender, setIsFirstRender] = useState(true)

  const isDemoMode = !!sessionStorage.getItem('mode')
  const isTutorialEnabled = features?.tutorial

  useEffect(() => {
    if (isDemoMode && isTutorialEnabled) {
      setShowPendingModal(false)
      return
    }

    if (
      isFirstRender &&
      activeTab === TABS.requestsToBeApproved &&
      !isEmpty(closeToAutoApproved) &&
      isEmpty(requestOrder)
    ) {
      setShowPendingModal(true)
    }

    setIsFirstRender(false)
  }, [isFirstRender, activeTab, closeToAutoApproved, requestOrder, isDemoMode, isTutorialEnabled])

  const onClickTab = tab => {
    if (tab === TABS.requestsToBeApproved && activeTab !== TABS.requestsToBeApproved) {
      if (!isEmpty(closeToAutoApproved) && isEmpty(requestOrder)) {
        setShowPendingModal(true)
      }
    }
    setActiveTab(tab)
  }

  return { TABS, onClickTab, showPendingModal, activeTab, isFetchingCart, requestOrder, setShowPendingModal }
}

export default useApproverCartsTabs
